import { render, staticRenderFns } from "./abnormalFromView.vue?vue&type=template&id=19e81576"
import script from "./abnormalFromView.vue?vue&type=script&lang=js"
export * from "./abnormalFromView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports